import "./App.scss";
import "./styles/theme.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import Home from "./pages/public/Home";
import Register from "./pages/public/Register";
import AdminLayout from "./components/AdminLayout/AdminLayout";

export interface ILoader {
    loading: boolean,
    setLoading: Function,
}

function App() {

    const [loading, setLoading] = useState<boolean>(false);

    const loader = () => {
        return <div>
            <div className="bg-loader-webinar"/>
            <div className="loader-webinar">
                <TailSpin color="#0041B9"/>
            </div>
        </div>
    }

    const handleLoader: ILoader = {
        loading: loading,
        setLoading: setLoading,
    }

    return (
        <div className="App">
            <header className="App-header">
                <Router>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/register/:id" element={<Register />} />
                        <Route path="/admin/*" element={<AdminLayout handleLoader={handleLoader} />} />
                    </Routes>
                </Router>
            </header>
            { loading && loader() }
        </div>
    );
}

export default App;
